/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Currency held in escrow
 * @export
 */
export const EscrowCurrency = {
    FUEL: 'FUEL',
    USD: 'USD'
} as const;
export type EscrowCurrency = typeof EscrowCurrency[keyof typeof EscrowCurrency];


export function instanceOfEscrowCurrency(value: any): boolean {
    for (const key in EscrowCurrency) {
        if (Object.prototype.hasOwnProperty.call(EscrowCurrency, key)) {
            if (EscrowCurrency[key as keyof typeof EscrowCurrency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EscrowCurrencyFromJSON(json: any): EscrowCurrency {
    return EscrowCurrencyFromJSONTyped(json, false);
}

export function EscrowCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscrowCurrency {
    return json as EscrowCurrency;
}

export function EscrowCurrencyToJSON(value?: EscrowCurrency | null): any {
    return value as any;
}

export function EscrowCurrencyToJSONTyped(value: any, ignoreDiscriminator: boolean): EscrowCurrency {
    return value as EscrowCurrency;
}

